import 'bootstrap';
import 'jquery.easing';

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init({
    duration: 1500, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
});


(function($) {
  "use strict"; // Start of use strict

  /*
   * Smooth scrolling using jQuery easing
   */
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 49)
        }, 1000, "easeInOutExpo");
        return false;
      }
    }
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function() {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#mainNav',
    offset: 56
  });

    /* 
    *    S H R I N K I N   H E A D E R
     */

    $(function(){
        $('#mainNav').data('size','big');
    });

    $(window).scroll(function(){
        if($(document).scrollTop() > 0)
        {
            if($('#mainNav').data('size') == 'big')
            {
                $('#mainNav').removeClass( "big" ).addClass( "small" );
                $('#mainNav').data('size','small');
                $('#mainNav').stop().animate({
                    height:'5rem'
                },800);
            }
        }
        else
        {
            if($('#mainNav').data('size') == 'small')
            {
                $('#mainNav').removeClass( "small" ).addClass( "big" );
                $('#mainNav').data('size','big');
                $('#mainNav').stop().animate({
                    height:'9rem'
                },800);
            }
        }
    });

    /*
    *    »Scroll Back To Top«-Button mit jQuery
    *    Der Button wird mit JavaScript erzeugt und vor dem Ende des body eingebunden.
    */

    var back_to_top_button = [''].join("");
    $("body").append(back_to_top_button);

    // Der Button wird ausgeblendet
    $(".back-to-top").hide();

    // Funktion für das Scroll-Verhalten
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) { // Wenn 100 Pixel gescrolled wurde
                $('.back-to-top').fadeIn();
            } else {
                $('.back-to-top').fadeOut();
            }
        });

        $('.back-to-top').click(function () { // Klick auf den Button
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });

})(jQuery); // End of use strict
